<div class="container responsive-grid webcam-container m-t-10">
    <div *ngIf="stream" class="webcam-preview">
        <div class="webcam-preview-text">
            <h3>{{ 'LABEL.WEBCAM_LABEL' | translate }}</h3>
        </div>
    </div>
</div>

<mat-card class="cardWithShadow">
    <mat-card-content class="p-y-10">
        <div class="row">
            <div class="col-6">
                <mat-card-title class="f-s-16">
                    {{ 'LABEL.WEBCAM' | translate }}
                </mat-card-title>
                <webcam [trigger]="$trigger" (imageCapture)="snapshot($event)" [imageQuality]="1" [height]="200"
                    [width]="200" *ngIf="stream">
                </webcam>
                <img src="assets/images/profile/user-1.jpg" alt="user" class="rounded w-100 m-t-8" width="200px"
                    height="200px" *ngIf="!stream" />
            </div>
            <div class="col-6">
                <div *ngIf="previewImage">
                    <mat-card-title class="f-s-16">
                        {{ 'LABEL.CAPTURE_PHOTO' | translate }}
                    </mat-card-title>
                    <img [src]="previewImage" height="150" width="200">

                </div>
            </div>
        </div>

        <button mat-flat-button color="primary" class="btnCheckPermissions bg-primary text-white w-100 m-t-8 m-b-10" (click)="captureImage()">
            {{btnLabel}}
        </button>


        <button (click)="proceed()" class="btnCheckPermissions bg-primary text-white w-100 m-t-8 m-b-10"
            *ngIf="previewImage">
            {{ 'BUTTON.BTN_PROCEED' | translate }}</button>
    </mat-card-content>
</mat-card>